/*
 * Keeps the total printed on the checkout button in sync with the cart.
 *
 * The button lives in its own section block, outside the container every cart
 * refresh re-renders (`.js-contents` on the cart page, `.cart-drawer__footer`
 * in the drawer), so its price kept the value from page load until a reload.
 * Quantity changes, gifts, upsells and discount codes each refresh the cart
 * their own way, so instead of teaching every path about the button we mirror
 * the estimated total, which all of them do re-render and which comes from the
 * same `cart.total_price | money` in Liquid.
 */

const CHECKOUT_PRICE_ROOTS = ['#main-cart-footer', 'cart-drawer'];
const TOTAL_SELECTOR = '.totals__total-value';
const BUTTON_PRICE_SELECTOR = '.cart__checkout-button-price-value';

function syncCheckoutButtonPrice(root) {
  const total = root.querySelector(TOTAL_SELECTOR);
  const buttonPrice = root.querySelector(BUTTON_PRICE_SELECTOR);
  if (!total || !buttonPrice) return;

  const value = total.textContent.trim();
  // Guard against reacting to our own write: the observer sees this mutation too.
  if (!value || buttonPrice.textContent.trim() === value) return;
  buttonPrice.textContent = value;
}

function observeCheckoutButtonPrice(root) {
  const observer = new MutationObserver(() => syncCheckoutButtonPrice(root));
  observer.observe(root, { childList: true, subtree: true, characterData: true });
  syncCheckoutButtonPrice(root);
}

CHECKOUT_PRICE_ROOTS.forEach((selector) => {
  const root = document.querySelector(selector);
  if (root) observeCheckoutButtonPrice(root);
});
